module.exports = __webpack_public_path__ + "img/1F1F2-1F1F3.3769a909.svg";